// extracted by mini-css-extract-plugin
export default {"smallCardDimensions":"CredentialsCard_smallCardDimensions__8dpY8","subtitleBold":"CredentialsCard_subtitleBold__Qv5MR","subtitleRegular":"CredentialsCard_subtitleRegular__6Iymm"};